import script from "./ViewStudentFinalGradeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewStudentFinalGradeDialog.vue?vue&type=script&setup=true&lang=js"

import "./ViewStudentFinalGradeDialog.vue?vue&type=style&index=0&id=008d2e48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008d2e48"]])

export default __exports__